var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "16x16/Favorite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.6526123,19.8842501 L11.5356123,17.3302501 C11.8256123,17.1782501 12.1716123,17.1782501 12.4626123,17.3302501 L17.3446123,19.8842501 C17.4026123,19.9142501 17.4556123,19.9382501 17.5016123,19.9562501 C17.4996123,19.9082501 17.4926123,19.8542501 17.4826123,19.7932501 L16.5496123,14.3842501 C16.4936123,14.0592501 16.6016123,13.7262501 16.8396123,13.4962501 L20.7896123,9.6662501 C20.8326123,9.6242501 20.8686123,9.5852501 20.8986123,9.5492501 C20.8516123,9.5372501 20.7976123,9.5272501 20.7366123,9.5182501 L15.2776123,8.7292501 C14.9526123,8.6822501 14.6706123,8.4782501 14.5246123,8.1832501 L12.0836123,3.2622501 C12.0546123,3.2042501 12.0256123,3.1542501 11.9986123,3.1122501 C11.9716123,3.1542501 11.9426123,3.2042501 11.9136123,3.2622501 L9.4726123,8.1832501 C9.3266123,8.4782501 9.0456123,8.6822501 8.7196123,8.7292501 L3.2606123,9.5182501 C3.1996123,9.5272501 3.1456123,9.5372501 3.0986123,9.5492501 C3.1286123,9.5852501 3.1656123,9.6242501 3.2076123,9.6662501 L7.1576123,13.4962501 C7.3956123,13.7262501 7.5036123,14.0592501 7.4476123,14.3842501 L6.5146123,19.7932501 C6.5046123,19.8542501 6.4976123,19.9082501 6.4956123,19.9562501 C6.5416123,19.9382501 6.5946123,19.9142501 6.6526123,19.8842501 Z M11.9986123,19.3452501 L7.5796123,21.6562501 C5.7646123,22.6052501 4.1966123,21.4692501 4.5436123,19.4532501 L5.3866123,14.5652501 L1.8156123,11.1022501 C0.342612302,9.6732501 0.945612302,7.8322501 2.9746123,7.5382501 L7.9146123,6.8242501 L10.1226123,2.3732501 C11.0306123,0.541250102 12.9676123,0.543250102 13.8746123,2.3732501 L16.0826123,6.8242501 L21.0226123,7.5382501 C23.0536123,7.8322501 23.6536123,9.6742501 22.1816123,11.1022501 L18.6106123,14.5652501 L19.4536123,19.4532501 C19.8016123,21.4712501 18.2306123,22.6042501 16.4176123,21.6562501 L11.9986123,19.3452501 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "16x26/Favorite",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "shape",
    width: "16px",
    height: "16px",
    fill: "#d3d4d6",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/Favorite.290ff8f5e834a28c54c01384ac235622.svg";
export { ForwardRef as ReactComponent };